





import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
  name: "bs-row"
})
export default class BsRowComponent extends Vue {
  @Prop({ default: false })
  noGutters!: boolean;

  @Prop({ default: false })
  h100!: boolean;

  @Prop({ default: null })
  justifyContentEnd: boolean;

  @Prop({ default: null })
  justifyContentCenter: boolean;

  @Prop({ default: null })
  alignItemsCenter: boolean;

  @Prop({ default: null })
  alignItemsBaseline: boolean;

  @Prop({ type: Number, default: null })
  ml: Number;

  @Prop({ type: Number, default: null })
  mr: Number;

  @Prop({ type: Number, default: null })
  mt: Number;

  @Prop({ type: Number, default: null })
  mb: Number;

  @Prop({ type: Number, default: null })
  mx: Number;

  @Prop({ type: Number, default: null })
  my: Number;

  @Prop({ type: Number, default: null })
  pl: Number;

  @Prop({ type: Number, default: null })
  pr: Number;

  @Prop({ type: Number, default: null })
  pt: Number;

  @Prop({ type: Number, default: null })
  pb: Number;

  @Prop({ type: Number, default: null })
  px: Number;

  @Prop({ type: Number, default: null })
  py: Number;

  @Prop({ default: null })
  dXlBlock: boolean;

  @Prop({ default: null })
  dLgBlock: boolean;

  @Prop({ default: null })
  dMdBlock: boolean;

  @Prop({ default: null })
  dSmBlock: boolean;

  @Prop({ default: null })
  dXlNone: boolean;

  @Prop({ default: null })
  dLgNone: boolean;

  @Prop({ default: null })
  dMdNone: boolean;

  @Prop({ default: null })
  dSmNone: boolean;

  GetClass() {
    var css: any = {};
    css["h-100"] = this.h100;
    css["no-gutters"] = this.noGutters;
    css["justify-content-end"] = this.justifyContentEnd != null;
    css["justify-content-center"] = this.justifyContentCenter != null;
    css["align-items-center"] = this.alignItemsCenter != null;
    css["align-items-baseline"] = this.alignItemsBaseline != null;
    css[`ml-${this.ml}`] = this.ml != null;
    css[`mt-${this.mt}`] = this.mt != null;
    css[`mr-${this.mr}`] = this.mr != null;
    css[`mb-${this.mb}`] = this.mb != null;
    css[`my-${this.my}`] = this.my != null;
    css[`mx-${this.mx}`] = this.mx != null;

    css[`pl-${this.pl}`] = this.pl != null;
    css[`pt-${this.pt}`] = this.pt != null;
    css[`pr-${this.pr}`] = this.pr != null;
    css[`pb-${this.pb}`] = this.pb != null;
    css[`py-${this.py}`] = this.py != null;
    css[`px-${this.px}`] = this.px != null;

    css["d-xl-block"] = this.dXlBlock;
    css["d-lg-block"] = this.dLgBlock;
    css["d-md-block"] = this.dMdBlock;
    css["d-sm-block"] = this.dSmBlock;

    css["d-xl-none"] = this.dXlNone;
    css["d-lg-none"] = this.dLgNone;
    css["d-md-none"] = this.dMdNone;
    css["d-sm-none"] = this.dSmNone;

    return css;
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/components/bootstrap/bs-row.vue